var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsxAxisIcon = function SvgDsxAxisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.431 1.716c-.275-.256-.691-.246-.93.021L8 4.553 5.498 1.737c-.238-.267-.654-.277-.929-.021s-.305.68-.067.949L7.09 5.578 4.502 8.49c-.238.268-.208.693.067.949s.691.246.93-.022L8 6.602l2.502 2.816c.238.268.654.278.929.022s.305-.681.067-.95L8.91 5.579l2.588-2.913c.238-.268.208-.693-.067-.95M11.863 10.691c.26-.26.68-.26.94 0l2 2c.26.26.26.681 0 .94l-2 2a.665.665 0 0 1-.94-.94l.865-.864H1.372a.665.665 0 1 1 0-1.33h11.356l-.865-.865a.665.665 0 0 1 0-.94"
  })));
};
export default SvgDsxAxisIcon;